import React, { useEffect } from 'react';
import classNames from 'classnames';
import CustomRadio from 'components/CustomRadio/CustomRadio';
import { translate } from 'components/Translation';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CustomInput from 'components/CustomInput/CustomInput';
import Button from 'components/CustomButtons/Button';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import style from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/linesStyle';
import { makeStyles } from '@material-ui/core';
import { BodyM } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(style);

interface ILinesProps {
	numberOfLines: number;
	lines: Array<types.services.fixed.ILine>;
	handleIncreaseNumberOfLines: VoidFunction;
	handleDecreaseNumberOfLines: VoidFunction;
	handleOneLine: VoidFunction;
	handleManyLines: VoidFunction;
	setNextStepDisabled: (nextStepDisabled: boolean) => void;
	linesEl: React.ReactElement[];
	handleRemoveItem: (ind: number) => void;
}

const LinesTab = (props: ILinesProps) => {
	const {
		numberOfLines,
		handleIncreaseNumberOfLines,
		handleDecreaseNumberOfLines,
		handleOneLine,
		handleManyLines,
		setNextStepDisabled,
		linesEl,
	} = props;

	const classes = useStyles();

	useEffect(() => {
		setNextStepDisabled(false);
	}, [setNextStepDisabled]);

	return (
		<div>
			<div className={classes.subtitle}>
				<BodyM color="secondary-light" disableMargin>
					{translate('add.new.line.fixed.lines.subtitle')}
				</BodyM>
			</div>
			<div>
				<CustomRadio checked={numberOfLines === 1} onChange={() => handleOneLine()} label={translate('one')} />
				<CustomRadio checked={numberOfLines > 1} onChange={() => handleManyLines()} label={translate('many')} />
			</div>
			<ConditionalRender
				show={numberOfLines > 1}
				onTrue={() => (
					<div>
						<div className={classNames(classes.center, classes.inputText)}>
							<span className={classes.minusPlus}>
								<Button
									size="sm"
									justIcon
									round
									color="tertiary-light"
									onClick={() => handleDecreaseNumberOfLines()}
								>
									<Remove />
								</Button>
							</span>
							<span className={classes.inputContainer}>
								<CustomInput
									variant="outlined"
									inputProps={{
										value: numberOfLines,
										onChange: () => {},
									}}
								/>
							</span>
							<span className={classes.minusPlus}>
								<Button
									onClick={() => handleIncreaseNumberOfLines()}
									justIcon
									round
									color="primary-light"
									size="sm"
								>
									<Add />
								</Button>
							</span>
						</div>
					</div>
				)}
			/>
			<div>{linesEl}</div>
		</div>
	);
};

export default LinesTab;
